<template>
  <div class="flexible-content-wrapper">
    <div class="flexible-content-header">
      <slot name="header"></slot>
    </div>
    <div class="flexible-content" v-scrollable>
      <slot></slot>
    </div>
    <div class="flexible-content-footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>

export default {
  name: 'FlexibleContent'
}
</script>

<style lang="scss" scoped>
.flexible-content-wrapper {
  display: flex;
  flex-direction: column;

  .flexible-content {
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    padding: 0 var(--side-padding);

    &-footer, &-header {
      padding: 0 var(--side-padding);
    }
  }
}
</style>